import { render, staticRenderFns } from "./AssetPicker.vue?vue&type=template&id=07654581&"
import script from "./AssetPicker.vue?vue&type=script&lang=js&"
export * from "./AssetPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports